module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiIGZpbGw9IiNGNkY4RjAiPgogIDxwYXRoIGQ9Ik0yLjk3IDBsLTIuOTcgM2gydjVoMnYtNWgybC0zLjAzLTN6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxKSIgLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/up.svg
// module id = 450
// module chunks = 35783957827783